/**
 * Purpose: Parse the free-text contact_phone field ("digits separated by
 *          space/comma") into actionable numbers and WhatsApp links.
 * Inputs: raw contact_phone string.
 * Outputs: splitPhoneNumbers(raw) → string[]; toWhatsAppUrl(phone) → wa.me URL
 *          (Pakistan-aware: leading 0 → 92) or null.
 */
export const splitPhoneNumbers = (raw) =>
  (raw || '')
    .split(/[,\s]+/)
    .map((p) => p.trim())
    .filter(Boolean);

export const firstPhoneNumber = (raw) => splitPhoneNumbers(raw)[0] || null;

export const toWhatsAppUrl = (phone) => {
  const digits = (phone || '').replace(/\D/g, '');
  if (!digits) return null;
  // Local Pakistani format (03xx…) → international 92…
  const international = digits.startsWith('0') ? `92${digits.slice(1)}` : digits;
  return `https://wa.me/${international}`;
};
